import styled from "styled-components";

export const Title = styled.div`
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 0.5rem;
`;
